export default __webpack_public_path__ + "static/giotto-plus-4-365f06dcfd1968afe4b710a23a72a66e.jpg";